import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.checklist.list');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-page-checklist-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.checklist.list/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageChecklistListComponent implements OnInit {
    public list: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 10;
    public searchText: string = '';
    public statusFilter: string = '';

    // 생성 모달
    public showCreateModal: boolean = false;
    public createMode: string = ''; // '' | 'generic' | 'inspection' | 'sports'
    public templates: any[] = [];
    public selectedTemplateId: string = '';
    public newTitle: string = '';
    public isCreating: boolean = false;

    // 시설물 유형 (정기안전점검)
    public facilityTypes = [
        { code: 'bridge', label: '교량, 육교', icon: 'fa-bridge' },
        { code: 'tunnel', label: '터널, 지하차도', icon: 'fa-archway' },
        { code: 'retaining_wall', label: '옹벽', icon: 'fa-border-all' },
        { code: 'cut_slope', label: '절토사면', icon: 'fa-mountain' },
        { code: 'building', label: '건축물, 지하도상가', icon: 'fa-building' },
    ];

    // 체육시설 유형
    public sportsFacilityTypes = [
        { code: 'soccer_field', label: '축구장', icon: 'fa-futbol' },
        { code: 'baseball_field', label: '야구장', icon: 'fa-baseball' },
        { code: 'indoor_arena', label: '실내경기장(배구, 농구)', icon: 'fa-volleyball' },
    ];

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.load();
        await this.service.loading.hide();
        this.ref.detectChanges();
    }

    public async load(page: number = 1) {
        this.page = Math.max(1, page);
        const { code, data } = await wiz.call('list', {
            page: this.page,
            dump: this.dump,
            text: this.searchText,
            status: this.statusFilter
        });
        if (code === 200) {
            this.list = data.list || [];
            this.total = data.total || 0;
        }
        window.scrollTo(0, 0);
        this.ref.detectChanges();
    }

    public get pages(): number[] {
        const totalPages = Math.ceil(this.total / this.dump);
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    // ===== 생성 모달 =====
    public async openCreateModal() {
        this.showCreateModal = true;
        this.createMode = '';
        this.selectedTemplateId = '';
        this.newTitle = '';
        this.templates = [];
        this.isCreating = false;
        await this.service.render();
    }

    public closeCreateModal() {
        this.showCreateModal = false;
        this.createMode = '';
        this.selectedTemplateId = '';
        this.newTitle = '';
        this.isCreating = false;
        this.ref.detectChanges();
    }

    public async selectCreateMode(mode: string) {
        this.createMode = mode;
        if (mode === 'inspection') {
            const { code, data } = await wiz.call('get_templates', { form_type: 'inspection' });
            if (code === 200) {
                this.templates = data || [];
            }
        } else if (mode === 'sports') {
            const { code, data } = await wiz.call('get_templates', { form_type: 'sports' });
            if (code === 200) {
                this.templates = data || [];
            }
        }
        this.ref.detectChanges();
    }

    public selectTemplate(templateId: string) {
        this.selectedTemplateId = templateId;
        const tpl = this.templates.find((t: any) => t.id === templateId);
        if (tpl && !this.newTitle) {
            this.newTitle = tpl.title;
        }
        this.ref.detectChanges();
    }

    public getFacilityLabel(facilityType: string): string {
        const ft = this.facilityTypes.find(f => f.code === facilityType)
            || this.sportsFacilityTypes.find(f => f.code === facilityType);
        return ft ? ft.label : facilityType;
    }

    public getFacilityIcon(facilityType: string): string {
        const ft = this.facilityTypes.find(f => f.code === facilityType)
            || this.sportsFacilityTypes.find(f => f.code === facilityType);
        return ft ? ft.icon : 'fa-file-lines';
    }

    public async confirmCreate() {
        if (this.isCreating) return;
        this.isCreating = true;
        await this.service.render();
        await this.service.loading.show();
        try {
            if (this.createMode === 'generic') {
                const { code, data } = await wiz.call('create', {
                    title: this.newTitle || '새 체크리스트'
                });
                if (code === 200 && data.id) {
                    this.closeCreateModal();
                    this.service.href(`/checklist/edit/${data.id}`);
                    return;
                }
            } else if ((this.createMode === 'inspection' || this.createMode === 'sports') && this.selectedTemplateId) {
                const { code, data } = await wiz.call('create', {
                    title: this.newTitle || '',
                    template_id: this.selectedTemplateId
                });
                if (code === 200 && data.id) {
                    this.closeCreateModal();
                    this.service.href(`/checklist/edit/${data.id}`);
                    return;
                }
            }
        } catch (e) {
            console.error('Create checklist error:', e);
        }
        await this.service.loading.hide();
        this.isCreating = false;
        await this.service.render();
    }

    public editChecklist(id: string) {
        this.service.href(`/checklist/edit/${id}`);
    }

    public async deleteChecklist(id: string, event: Event) {
        event.stopPropagation();
        const confirmed = await this.service.alert.show({
            title: '삭제 확인',
            message: '이 체크리스트를 삭제하시겠습니까? 관련된 모든 응답 데이터도 함께 삭제됩니다.',
            status: 'warning',
            action: '삭제',
            actionBtn: 'danger',
            cancel: '취소'
        });
        if (!confirmed) return;

        const { code } = await wiz.call('delete', { id });
        if (code === 200) {
            await this.load(this.page);
        }
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        return dateStr.split(' ')[0];
    }

    public statusLabel(status: string): string {
        const map: any = { draft: '초안', published: '게시됨', archived: '보관' };
        return map[status] || status;
    }

    public statusColor(status: string): string {
        const map: any = {
            draft: 'bg-yellow-50 text-yellow-700',
            published: 'bg-green-50 text-green-700',
            archived: 'bg-slate-100 text-slate-500'
        };
        return map[status] || 'bg-slate-100 text-slate-500';
    }

    public formTypeLabel(formType: string): string {
        const map: any = {
            inspection: '정기안전점검',
            sports: '체육시설',
            generic: '일반',
        };
        return map[formType] || '일반';
    }

    public formTypeColor(formType: string): string {
        const map: any = {
            inspection: 'bg-blue-50 text-blue-700',
            sports: 'bg-emerald-50 text-emerald-700',
            generic: 'bg-slate-50 text-slate-500',
        };
        return map[formType] || 'bg-slate-50 text-slate-500';
    }

    public async onSearch() {
        await this.load(1);
    }

    public async filterByStatus(status: string) {
        this.statusFilter = this.statusFilter === status ? '' : status;
        await this.load(1);
    }
}

export default PageChecklistListComponent;